<div class = "body">

    <div class ="container" style = "height:100px"> </div>

    <div class = "container principal" style = "background-color: white; padding-top: 50px; padding-bottom:50px">

        <div class = "alert alert-danger alert-dismissible fade show" role = "alert" *ngIf = "mensaje">

            <strong> Error! </strong> {{mensajeError}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

        <div class = "row">

            <div class = "col-lg-8"> <h1> Bienvenido/a {{nombreUsuario}} </h1> </div>

            <div class = "col-lg-4"> </div>

        </div> <br/>

        <div class = "row">
 <!-- 
            <div class = "col-lg-12"> <p> Utilice el menú para acceder a las funcionalidades de la aplicación.</p> </div>
 -->
        </div>

    </div>
    <!--
    <br/>   
    <div class = "container principal">
        <div class = "col-lg-12"> <p> A contar del día <b>MIERCOLES 05 DE MAYO DE 2021 </b>, el Servicio de Bienestar ha suscrito un Contrato de Seguro Colectivo de Vida y Complementario de Salud.
          <br/>
          <br/>
            Esto significa que <b> seguiremos usando la Plataforma de Reembolso Médicos de Bienestar</b>, pero los porcentajes que se aplicarán al reembolso de beneficios estarán determinados por la fecha de emisión de los documentos y, por ende, podrían sufrir variación.
          </p>
            <br/>
        </div>
    </div>
     -->
    <br/>
    <!-- 
    <div class = "container principal">
        <div class = "col-lg-12"> 
          <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben conservar los originales de los documentos </b>
           <br/>
           <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b>
           <br/>
           <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b>  Dictamen N° 467/2021. 
          </p>         
           <br/>       
        </div>
    </div>
    -->
   
    <div class = "container principal">
      <div class = "col-lg-12" style="font: 400 18px/20px Roboto"> 
        <p>Según lo indicado por la SUSESO, <b>los afiliados deben conservar los originales de los documentos de respaldo de los </b>
          <br/>
          <b>beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b> (Circular N°3623 de fecha 18.10.2021)
          <br/>
          <br/>
          La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual 
          conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario  administrativo.   
          <br/>
          <br/>
          Por otro lado, le recordamos que a contar del 05-05-2025 y hasta el 04-05-2027 los reembolsos médicos son gestionados por cía. de seguros Vida Cámara.
          </p>         
          <br/>     
      </div>
   </div>

  

     <!--
      <div class = "container principal">
        <div class = "col-lg-12"> <h1><p>  Estimado usuario(a).    </p></h1>
          <br/>
          <br/>
          <h1><p>
          <b>Estamos en proceso de Mantención, </b>
          pronto volveremos a estar disponibles.
          </p> </h1>
            <br/>
        </div>
      </div>
    -->
</div>
